import { default as SearchPage } from './SearchPage';

export default SearchPage;
